import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import PlacementsTabStep from 'onboarding/onboardings/ProjectPlacementsOnboarding/steps/PlacementsTabStep';
import PlacementsStatusCellStep
  from 'onboarding/onboardings/ProjectPlacementsOnboarding/steps/PlacementsStatusCellStep';
import BodyScroll from 'utils/BodyScroll';
import router from 'router';
import store from 'store';
import PlacementCreateStep from 'onboarding/onboardings/ProjectPlacementsOnboarding/steps/PlacementCreateStep';
import appEventBus from 'appEventBus';


class ProjectPlacementsOnboarding extends BaseOnboarding {
  static get name () {
    return 'project-placements-list-onboarding';
  }

  static get trackingName () {
    return 'onboarding_placements';
  }

  async checkCondition () {
    const route = router.currentRoute;
    const routeName = route.name;

    return routeName === 'placementsList';
  }

  steps () {
    return [
      {
        target: '.header-tabs__tabs .tabs__placements-tab',
        attachToHighlight: false,
        header: 'Размещения',
        component: PlacementsTabStep,
        params: {
          placement: 'bottom',
          enableScrolling: true,
          modifiers: {
            offset: {
              offset: '0,8'
            }
          }
        },
        events: {
          on () {
            BodyScroll.disable();
            window.ymReachGoal('ONBOARDING_PLACEMENTS_START');
          },
          off () {
            BodyScroll.enable();
          }
        },
        width: '408px',
        highlightTarget: '.header-tabs__tabs .tabs',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      {
        target: '.placements-table-container thead tr :nth-child(3)',
        attachToHighlight: false,
        header: 'Управляйте кампаниями из системы',
        component: PlacementsStatusCellStep,
        params: {
          placement: 'top',
          enableScrolling: false,
          modifiers: {
            offset: {
              offset: '0,8'
            }
          }
        },
        events: {
          on () {
            BodyScroll.disable();
          },
          off () {
            BodyScroll.enable();
          }
        },
        width: '408px',
        highlightTarget: '.placements-table-container .wide-table-container',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 4,
          maskSizeOffsetY: 8
        }
      },
      store.getters['user/canUser']('CREATE_PLACEMENT') ? {
        target: '.btn-new-placements',
        attachToHighlight: false,
        header: 'Размещения добаляются из привязок ',
        params: {
          placement: 'left',
          enableScrolling: false
        },
        component: PlacementCreateStep,
        events: {
          on () {
            BodyScroll.disable();
          },
          off () {
            BodyScroll.enable();
            appEventBus.$emit('AUTORUN_ONBOARDING_COMPLETE');
            window.ymReachGoal('ONBOARDING_PLACEMENTS_COMPLETE');
          }
        },
        width: '408px',
        highlightTarget: '.btn-new-placements',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 8,
          maskSizeOffsetY: 8,
          allowClickInside: true
        }
      } : null
    ].filter(s => Boolean(s));
  }
}

export default ProjectPlacementsOnboarding;
